import { createSlice } from '@reduxjs/toolkit'

import { requestMdfActivitiesData } from './thunks/requestMdfActivitiesData'
import { requestMdfActivityApply } from './thunks/requestMdfActivityApply'
import { IMdfActivitiesState } from './types'

const initialState: IMdfActivitiesState = {
  records: [],
  isLoading: false,
  error: null,
  loadedContext: null,
  savingEntryIds: [],
}

const mdfActivitiesSlice = createSlice({
  name: 'mdfActivities',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(requestMdfActivitiesData.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(requestMdfActivitiesData.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message ?? 'Failed to fetch MDF activities'
      })
      .addCase(requestMdfActivitiesData.fulfilled, (state, action) => {
        state.isLoading = false
        state.records = action.payload
        state.loadedContext = {
          partnerId: action.meta.arg.partnerId,
          fYear: action.meta.arg.fYear,
          programType: action.meta.arg.programType,
        }
        state.error = null
      })
      .addCase(requestMdfActivityApply.pending, (state, action) => {
        const { entryId } = action.meta.arg.activity
        if (!state.savingEntryIds.includes(entryId)) {
          state.savingEntryIds.push(entryId)
        }
        state.error = null
      })
      .addCase(requestMdfActivityApply.fulfilled, (state, action) => {
        const { entryId } = action.meta.arg.activity
        state.savingEntryIds = state.savingEntryIds.filter((id) => id !== entryId)

        if (action.payload) {
          const index = state.records.findIndex((record) => record.entryId === entryId)
          if (index !== -1) {
            state.records[index] = action.payload
          }
        }
      })
      .addCase(requestMdfActivityApply.rejected, (state, action) => {
        const { entryId } = action.meta.arg.activity
        state.savingEntryIds = state.savingEntryIds.filter((id) => id !== entryId)
        state.error = action.error.message ?? 'Failed to update MDF activity link'
      })
  },
})

export const mdfActivitiesReducer = mdfActivitiesSlice.reducer
